import { useSubscription } from '@apollo/client/react';
import { NewNotificationSubscription } from './api.graphql';
import { useUserSession } from '@/contexts/UserSession';
import runtime from '@/runtime';

const useNewNotificationSync = () => {
    if (!runtime.organization) {
        throw new Error('Organization not found');
    }

    const { token, user } = useUserSession();

    if (!token) {
        throw new Error('Token not found');
    }

    if (!user) {
        throw new Error('User not found');
    }

    const result = useSubscription(NewNotificationSubscription, {
        variables: { token },
    });

    const payload = result?.data?.eventFromUserSession;

    if (payload?.__typename !== 'UserSessionBroadcast') {
        return null;
    }

    return payload.newNotificationEmittedAt;
};

export default useNewNotificationSync;
